import { updatedAt } from '@/pages/menu-managements/const';
import { Title } from '@/pages/menu-managements/services/title';

export const allocatedMenuTableColumn = {
  name: {
    key: 'name',
    label: '店舗名',
    width: '250px',
  },
  menuAndMenuHour: {
    key: 'menu_and_business_hours',
    label: 'メニュー名と提供時間',
    width: '500px',
  },
  updatedAt: {
    ...updatedAt,
    width: '180px',
  },
} as const;

const tableColumns = [
  allocatedMenuTableColumn.name,
  allocatedMenuTableColumn.menuAndMenuHour,
  allocatedMenuTableColumn.updatedAt,
] as const;

export const allocatedMenuTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export type MenuSet = {
  brand_menu: {
    id: string;
    title: Title;
  };
  brand_menu_hour: {
    id: string;
    title: Title;
  };
};

export type MenuManagementDeliveryStore = {
  master_store_id: number;
  master_store_name: string;
  menu_sets: MenuSet[];
  updated_at: Date | null;
};

export type UpdateMenuSet = {
  brand_menu_id: string;
  brand_menu_hour_id: string;
  sort_index: number;
};

export const UNIQUE_ERROR_MESSAGE =
  'メニューとメニュー営業時間の組み合わせに重複があるため更新をすることできませんでした。';

export const areUnique = (menuSet: UpdateMenuSet[]): boolean => {
  const seenSet = new Set<string>();
  return menuSet.every(({ brand_menu_id, brand_menu_hour_id }) => {
    const key = `${brand_menu_id}-${brand_menu_hour_id}`;
    return !seenSet.has(key) && seenSet.add(key);
  });
};
